import { Observable } from 'rxjs';
import {
  ApiService,
  GET_USER_NOTIFICATIONS_PATH,
  MARK_NOTIFICATIONS_AS_READ_PATH,
  MarkNotificationsAsReadBody,
  MARK_NOTIFICATION_AS_CLICKED_PATH,
  MarkNotificationAsClickedPathParams,
  REGISTER_DEVICE_TOKEN_PATH,
  RegisterDeviceTokenBody,
  UNREGISTER_DEVICE_TOKEN_PATH,
  UnregisterDeviceTokenPathParams
} from '@core-http';
import { NotificationResponseDTO } from '../../application/interfaces';

/**
 * Wyjątek dla notificationsList(): zwraca lokalne NotificationResponseDTO zamiast typu z @core-http.
 * OpenAPI generuje NotificationDto.payload jako union type wielu różnych payload typów,
 * lokalne DTO z ujednoliconym interfejsem payload jest czytelniejsze.
 */
export class NotificationsService extends ApiService {
  registerToken(payload: RegisterDeviceTokenBody): Observable<void> {
    return this.httpClient.put<void>(`${this.env.apiUrl}${REGISTER_DEVICE_TOKEN_PATH}`, payload);
  }

  unregisterToken(pathParams: UnregisterDeviceTokenPathParams): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.env.apiUrl}${UNREGISTER_DEVICE_TOKEN_PATH.replace('{token}', pathParams.token)}`
    );
  }

  notificationsList(): Observable<NotificationResponseDTO> {
    return this.httpClient.get<NotificationResponseDTO>(`${this.env.apiUrl}${GET_USER_NOTIFICATIONS_PATH}`);
  }

  markAsRead(payload: MarkNotificationsAsReadBody): Observable<void> {
    return this.httpClient.patch<void>(`${this.env.apiUrl}${MARK_NOTIFICATIONS_AS_READ_PATH}`, payload);
  }

  markAsClicked(pathParams: MarkNotificationAsClickedPathParams): Observable<void> {
    return this.httpClient.patch<void>(
      `${this.env.apiUrl}${MARK_NOTIFICATION_AS_CLICKED_PATH.replace('{notificationId}', pathParams.notificationId)}`,
      null
    );
  }
}
